import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './card.scss';
import { cursorDataProps } from '../../../../props/feed-prop-types';

const Card = forwardRef(
  ({ cursorData, children, index, className, ...options }, ref) => {
    const classNames = () => {
      // react-feed-entry is being used by feed3 container for pagination -
      // see https://github.com/strava/active/blob/main/app/assets/javascripts/strava/dashboard/PaginationView.js.coffee#L52-L73
      const a = ['react-feed-entry', styles.feedEntry, styles.card, className];
      if (index > 0) {
        a.push(styles.cardMargin); // TODO [fumba] this is only needed for HAML injected feed entries
      }
      return a;
    };

    return (
      <div
        className={classNames().join(' ')}
        data-updated-at={cursorData.updated_at} // TODO [fumba] remove data-* once virtual feed is in prod. This is being used by legacy feed for pagination.
        data-rank={cursorData.rank}
        data-testid="web-feed-entry"
        ref={ref}
        {...options}
      >
        {children}
      </div>
    );
  }
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  cursorData: cursorDataProps.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string
};

Card.defaultProps = {
  className: null
};

export default Card;
